import { Injectable } from '@angular/core';
import { AppConstant } from '../utility/app-constant';
import { ApiEndPoint } from '../utility/api-end-point';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from './notification/notification.service';
import { HttpResponseMessage } from '../utility/http-response-message';
import { Router } from "@angular/router";
import { CacheService } from "./cache.service";
import { AppEnumConstants } from "../enums/app-enum-constants";
import { AuthOktaService } from "./auth/auth-okta.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {
  public networkStatus: boolean;
  public paymentConfig = true;
  public logoutSubject = new BehaviorSubject(null);

  constructor(public notificationService: NotificationService, private router: Router, private authOktaService: AuthOktaService) {
    this.networkStatus = true;
    this.init();
  }

  async init() {
    this.networkStatus = await this.checkInternetConnectivity();
    this.initEventListeners();
  }

  initEventListeners() {
    window.addEventListener('online', this.handleOnline.bind(this));
    window.addEventListener('offline', this.handleOffline.bind(this));
  }

  async handleOnline() {
    this.networkStatus = await this.checkInternetConnectivity();
    if (!this.networkStatus) {
      this.handleOffline();
    } else {
      this.notificationService.successMessage(HttpResponseMessage.BACK_ONLINE);
    }
  }

  handleOffline() {
    this.notificationService.infoMessage(HttpResponseMessage.NO_INTERNET);
    this.networkStatus = false;
  }

  async checkInternetConnectivity() {
    try {
      const response = await fetch('https://www.google.com', { mode: 'no-cors' });
      return response.ok || response.type === 'opaque'; // Opaque responses are typical for no-cors mode
    } catch (error) {
      return false;
    }
  }

  isAuthorized(access) {
    try {
      const obj = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR));
      return (obj.authorityList).includes(access);

    } catch (e) {
      this.logoutSubject.next(true);
    }
  }


  isAuthorizedMultiple(access: any[]) {
    try {
      const obj = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR));
      for (const item of access) {
        if ((obj.authorityList).includes(item)) {
          return true;
        }
      }
    } catch (e) {
      this.logoutSubject.next(true);
    }
  }

  isNoNetworkAvailable(): boolean {
    if (!this.networkStatus) {
      this.notificationService.infoMessage(HttpResponseMessage.NO_INTERNET);
    }
    return !this.networkStatus;
  }

  isPortal() {
    return ApiEndPoint.DOMAIN_NAME.includes(AppConstant.PORTAL_SYSTEM);
  }

  isVendor() {
    return ApiEndPoint.DOMAIN_NAME.includes(AppConstant.VENDOR_SYSTEM);
  }

  isSupport() {
    return ApiEndPoint.DOMAIN_NAME.includes(AppConstant.SUPPORT_SYSTEM);
  }

  isExusPartner() {
    return (window.location.hostname.includes(ApiEndPoint.EXUS_PARTNER));
  }

  isMobile(): boolean {
    return window.innerWidth < 990;
  }

  isDemo() {
    return ApiEndPoint.DEMO_ENV;
  }

  isPaymentConfig() {
    return this.paymentConfig;
  }

  isSwitchedToDelicate() {
    const user = JSON.parse(localStorage?.getItem(AppConstant.SESSION_USER_ATTR));
    return user?.switchedToDelegateAccount;
  }

  getCurrentDelicateUserDetails() {
    const user = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR));
    return user.delegateUserDetails;
  }

  isAuth0Enabled(): boolean {
    return !!this.authOktaService.hasOrganizationId();
  }

  navigateDashboard() {
    const navItems = localStorage.getItem('NAV_ITEMS');
    const parsedNavItems = JSON.parse(navItems);
    if (this.isPortal() && localStorage.getItem(AppConstant.SUB_CLIENT_ID) || parsedNavItems.dashBoardUrl !== '/home/dashboard') {
      this.router.navigateByUrl(parsedNavItems?.dashBoardUrl);
      return;
    }
    if (this.isPortal() && localStorage.getItem(AppConstant.SUB_CLIENT_ID) || parsedNavItems.dashBoardUrl === '/home/dashboard') {
      this.router.navigateByUrl('home/dashboard');
      return;
    }
    if (this.isPortal()) {
      this.router.navigateByUrl('home/portal-dashboard');
      return;
    }
    if (this.isSupport()) {
      this.router.navigateByUrl('support/dashboard');
      return;
    }
    if (this.isVendor()) {
      this.router.navigateByUrl('vendor/dashboard');
      return;
    }
    this.router.navigateByUrl('home/dashboard');
  }

}
